import React from "react";
import "./Event_Details_Banner.css";
const Event_Details_Banner = () => {
  return (
    <section className="Event_Details_Banner">
      <div className="container-fluid p-0">
        <div className="saguruaprpadiv">
          <img
            className="bannerimg"
            src={
              process.env.PUBLIC_URL +
              "/assets/images/event_details/banner/event_banner.png"
            }
            alt="sadguru-banner"
          />
        </div>
      </div>
    </section>
  );
};

export default Event_Details_Banner;
